<template>
    <div class="progress-step-bar">
        <ul class="steps">
            <li  v-for="i in length" :key="i" :class="[i <= step ? activeClass : '']"> </li>
        </ul>
    </div>
</template>

<script>
  export default {
    name: 'ProgressBar',

    props: {
      step: Number,
      length: Number,
    },

    data: () => {
      return {
        loading: true,
        activeClass: 'active'
      }
    },

    mounted () {
      this.loading = false
    },

    watch: {
      loading (to, from) {
        this.$emit('componentLoading', this.$options.name, to)
      }
    }
  }
</script>